const MRN_REGEXP = /^S?[0-9]+$/;

function mrn() {
  return {
    require: 'ngModel',
    link: function (scope, elm, attrs, ctrl) {
      ctrl.$validators.mrn = function (modelValue, viewValue) {

        if (ctrl.$isEmpty(modelValue)) {
          // consider empty models to be valid
          return true;
        }

        return MRN_REGEXP.test(viewValue);
      };

      let capitalise = function (value) {
        if (value === undefined) {
          value = '';
        }
        let capitalised = value.toUpperCase();
        if (capitalised !== value) {
          // see where the cursor is before the update so that we can set it back
          let selectionStart = elm[0].selectionStart;
          let selectionEnd = elm[0].selectionEnd;
          ctrl.$setViewValue(capitalised);
          ctrl.$render();
          // set back the cursor after rendering
          elm[0].selectionStart = selectionStart;
          elm[0].selectionEnd = selectionEnd;
        }
        return capitalised;
      };

      ctrl.$parsers.push(capitalise);
      capitalise(scope[attrs.ngModel]); // capitalise initial value
    }
  };
}

export default angular.module('mrn', [])
  .directive('mrn', mrn)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/directives/mrn.directive.js
 **/